import * as Scrivito from "scrivito";
import classNames from "classnames";
import { isBrowser } from "^/utils/isBrowser";
import GenericInputComponent from "../GenericInputComponent";
import FormFieldWrapper from "../FormFieldWrapper";
import SelectboxOptionWidgetComponent from "../SelectOptionWidget/SelectOptionWidgetComponent";
import { formInputId, getValidationResult } from "../../formHelpers";
import ErrorBlock from "../ErrorBlock";

class SelectboxWidgetComponent extends GenericInputComponent {
  render() {
    const { widget, inputsWithErrors } = this.props;
    const myStorage = isBrowser ? window.sessionStorage : {};
    const placeholder = widget.get("placeholder");
    const validation = getValidationResult(inputsWithErrors, widget.id());
    return (
      <div
        className={classNames("form-group p-0", {
          invalid: !!validation,
        })}
      >
        <FormFieldWrapper widget={widget} selectBox>
          <select
            id={formInputId(widget)}
            onChange={this.handleInputChange}
            value={myStorage.getItem(widget.id()) || ""}
            className="form-control"
          >
            <option id="select-placeholder" value="">
              {placeholder || ""}
            </option>
            {widget.get("options").map((option) => (
              <SelectboxOptionWidgetComponent
                key={option.id()}
                widget={option}
              />
            ))}
          </select>
        </FormFieldWrapper>
        <ErrorBlock validation={validation} lang={widget.obj().language()} />
      </div>
    );
  }
}

Scrivito.provideComponent("SelectboxWidget", SelectboxWidgetComponent);
